import React, { useEffect, useState } from "react";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import { getFile } from "sr/utils/api/getFile";
import { ChatLoader } from "./ChatLoader";
import { ModelWrapperWithButton } from "app/pages/company/component/ModelWrapperWithButton";

export const ChatImg = ({item, onImageLoad}: any) => {
    const [imageUrl, setImageUrl] = useState<string>()
    const [loader, setLoader] = useState(true)
    const [isExpanded, setIsExpanded] = useState(false)

    useEffect(()=> {
            const fetchImg = async (key)=> {
try {
const fileimg = await getFile(key)
  if(fileimg) {
    const newImageUrl = URL.createObjectURL(fileimg);
    setImageUrl(newImageUrl)
    setLoader(false)
  }
  else {
    setLoader(false)
  }
}
catch(e) {
setLoader(false)
}
            }
            if(item?.file_id) {
                fetchImg(item?.file_id)
            }
    },[item?.file_id])
  return (
    <>
      <div className="mt-2 mb-1">
      <ContentWithLoader loading={loader} 
      content={<ChatLoader />}>
      <img alt="Attachment" className={`cursor-pointer rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200 object-cover max-w-[240px] max-h-[240px] sm:max-w-[300px] sm:max-h-[300px] bg-gray-50`}
          src={imageUrl} onClick={() => setIsExpanded(true)} onLoad={onImageLoad} />
         </ContentWithLoader>
      </div>
      {isExpanded && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm"
          onClick={() => setIsExpanded(false)}
        >
          <div className="relative max-w-[90vw] max-h-[90vh]">
            <button 
              className="absolute -top-12 right-0 text-white hover:text-gray-300 p-2"
              onClick={() => setIsExpanded(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={imageUrl} 
              className='max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl' 
              alt="Expanded chat" 
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
    );};
